<div class="pnl-ancillary-nav ">
  <nav class="navbar navbar-expand-md ">
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <i class="fa fa-bars"></i>

    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav ms-auto">
        <li class="nav-item" [routerLinkActive]="['active']">
          <a class="nav-link" (click)="openCriteriaDialog()" (keyup.enter)="openCriteriaDialog()" tabindex="0" aria-label="Criteria">Criteria</a>
        </li>
        <li class="nav-item " >
          <a class="nav-link" (click)="openTermsConditionsDialog()" (keyup.enter)="openTermsConditionsDialog()" tabindex="0" aria-label="Terms and Conditions">Terms & Conditions</a>
        </li>
        <li class="nav-item " >
          <a class="nav-link" href="mailto:nationalevents@failteireland.ie" aria-label="Contact Us">Contact Us</a>
        </li>
      </ul>
    </div>
  </nav>
</div>